export const GET_LIAISONS_REQUEST = "GET_LIAISONS_REQUEST";
export const GET_LIAISONS_SUCCESS = "GET_LIAISONS_SUCCESS";
export const GET_LIAISONS_FAIL = "GET_LIAISONS_FAIL";
export const GET_SINGLE_LIAISON_REQUEST = "GET_SINGLE_LIAISON_REQUEST";
export const GET_SINGLE_LIAISON_SUCCESS = "GET_SINGLE_LIAISON_SUCCESS";
export const GET_SINGLE_LIAISON_FAIL = "GET_SINGLE_LIAISON_FAIL";
export const ADD_LIAISON_REQUEST = "ADD_LIAISON_REQUEST";
export const ADD_LIAISON_SUCCESS = "ADD_LIAISON_SUCCESS";
export const ADD_LIAISON_FAIL = "ADD_LIAISON_FAIL";
export const UPDATE_LIAISON_REQUEST = "UPDATE_LIAISON_REQUEST";
export const UPDATE_LIAISON_SUCCESS = "UPDATE_LIAISON_SUCCESS";
export const UPDATE_LIAISON_FAIL = "UPDATE_LIAISON_FAIL";
export const DELETE_LIAISON_REQUEST = "DELETE_LIAISON_REQUEST";
export const DELETE_LIAISON_SUCCESS = "DELETE_LIAISON_SUCCESS";
export const DELETE_LIAISON_FAIL = "DELETE_LIAISON_FAIL";
export const INVALIDATE_LIAISONS_CACHE = "INVALIDATE_LIAISONS_CACHE";
